/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiScreeningFlowTest,
    InternalApiScreeningFlowTestFromJSON,
    InternalApiScreeningFlowTestToJSON,
    InternalApiScreeningFlowTestResult,
    InternalApiScreeningFlowTestResultFromJSON,
    InternalApiScreeningFlowTestResultToJSON,
    InternalApiScreeningFlowTestRun,
    InternalApiScreeningFlowTestRunFromJSON,
    InternalApiScreeningFlowTestRunToJSON,
} from '../models';

export interface CreateScreeningTestForDraftRequest {
    draftId: number;
    internalApiScreeningFlowTest: InternalApiScreeningFlowTest;
}

export interface FindScreeningTestsForDraftRequest {
    draftId: number;
}

/**
 * 
 */
export class InternalScreeningTestsApi extends runtime.BaseAPI {

    /**
     * Runs a screening test against a draft
     */
    async createScreeningTestForDraftRaw(requestParameters: CreateScreeningTestForDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningFlowTestResult>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling createScreeningTestForDraft.');
        }

        if (requestParameters.internalApiScreeningFlowTest === null || requestParameters.internalApiScreeningFlowTest === undefined) {
            throw new runtime.RequiredError('internalApiScreeningFlowTest','Required parameter requestParameters.internalApiScreeningFlowTest was null or undefined when calling createScreeningTestForDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/screening-flow-drafts/{draftId}/tests`.replace(`{${"draftId"}}`, encodeURIComponent(String(requestParameters.draftId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScreeningFlowTestToJSON(requestParameters.internalApiScreeningFlowTest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningFlowTestResultFromJSON(jsonValue));
    }

    /**
     * Runs a screening test against a draft
     */
    async createScreeningTestForDraft(requestParameters: CreateScreeningTestForDraftRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningFlowTestResult> {
        const response = await this.createScreeningTestForDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists the tests run against a draft
     */
    async findScreeningTestsForDraftRaw(requestParameters: FindScreeningTestsForDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScreeningFlowTestRun>>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling findScreeningTestsForDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/screening-flow-drafts/{draftId}/tests`.replace(`{${"draftId"}}`, encodeURIComponent(String(requestParameters.draftId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScreeningFlowTestRunFromJSON));
    }

    /**
     * Lists the tests run against a draft
     */
    async findScreeningTestsForDraft(requestParameters: FindScreeningTestsForDraftRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScreeningFlowTestRun>> {
        const response = await this.findScreeningTestsForDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
